import type { FC, ReactNode } from 'react'

import { motion } from 'motion/react'
import { enter } from '@/lib/motion'
import { SplitText } from '@/components/motion/split-text'
import { Button } from '@/components/site/button'

export const CtaBlock: FC = (): ReactNode => {
    return (
        <section
            id='start-a-project'
            className='relative z-[2] flex w-full flex-col items-center gap-10 overflow-clip bg-background px-6 py-section-sm'
        >
            <h2
                aria-label="Build something worth keeping"
                className='z-[1] flex select-none flex-col items-center overflow-clip text-foreground'
            >
                <span className='flex w-min items-center gap-4 overflow-clip'>
                    <SplitText
                        text="Build"
                        effect='rise'
                        accessible={false}
                        className='t-display block whitespace-pre'
                    />

                    {' '}

                    <SplitText
                        text="something"
                        effect='rise'
                        delay={0.12}
                        accessible={false}
                        className='t-display-serif block whitespace-pre'
                    />
                </span>

                {' '}

                <motion.span
                    className='block'
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={enter(0.15)}
                >
                    <SplitText
                        text="Worth keeping"
                        effect='slide'
                        delay={0.2}
                        accessible={false}
                        className='t-display block whitespace-pre'
                    />
                </motion.span>
            </h2>

            <Button href='/contact' label="Work with me" size='md' />
        </section>
    )
}
